export { default as breakpoints } from "./resolution-variables";
